import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const containerStyles = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});

export const headerStyles = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.m,
  width: "100%",
});

export const inputWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const favouriteClubTitle = style({
  fontSize: vars.fontSizes.heading.m,
});

export const explainText = style({
  fontSize: vars.fontSizes.body.s,
});
